import React, {useEffect, useState} from 'react';
import {Box, Typography, TextField, Paper, styled} from '@mui/material';
import {useFormInput} from '../utils/utilities';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {clearAuthError, login} from '../actions';
import {CustomButton, PasswordInput} from '../components';
import {fieldError, isFieldIvalid} from '../utils/errorHandler';

const LoginPage = () => {
  const email = useFormInput('');
  const password = useFormInput('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {authLoading, authError} = useSelector(s => s.user);
  const disabled = !email.value || !password.value;

  const onSubmit = e => {
    e.preventDefault();

    dispatch(login(email.value, password.value));
  };

  const forgotPassword = () => {
    navigate('/forgot-password');
  };

  const clearError = () => {
    if (authError) {
      dispatch(clearAuthError());
    }
  };

  const passwordErrorMessage = () => {
    if (typeof authError === 'string' && authError !== '') {
      return authError;
    } else if (isFieldIvalid(authError, 'password')) {
      return fieldError(authError, 'password');
    }
    return '';
  };

  useEffect(() => {
    dispatch(clearAuthError());
  }, []);

  return (
    <Box
      display="flex"
      height="100vh"
      justifyContent="center"
      alignItems="center">
      <Paper sx={{padding: '2.5rem'}}>
        <form onSubmit={onSubmit}>
          <Box display="flex" flexDirection="column" width="25rem">
            <Typography mb="3rem" variant="h4" alignSelf="center">
              Login
            </Typography>
            <TextField
              error={isFieldIvalid(authError, 'email')}
              helperText={fieldError(authError, 'email')}
              {...email}
              required
              onChange={txt => {
                clearError();
                email.onChange(txt);
              }}
              label="Email"
            />
            <PasswordInput
              error={isFieldIvalid(authError, 'password')}
              helperText={passwordErrorMessage()}
              {...password}
              onChange={txt => {
                clearError();
                password.onChange(txt);
              }}
              sx={{marginTop: '1.25rem', marginBottom: '1.25rem'}}
            />
            <CustomButton
              loading={authLoading}
              disabled={disabled}
              type="submit">
              Login
            </CustomButton>
            <Link
              mt="1.25rem"
              alignSelf="center"
              color="tertiary700"
              onClick={forgotPassword}>
              Forgot password?
            </Link>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

const Link = styled(Typography)`
  cursor: pointer;
`;

export default LoginPage;
